import { NextApiRequestQuery } from 'next/dist/server/api-utils';
import { getQueryFromUrl } from 'utils/helpers/getQueryFromUrl';

export const getQueryFromWindow = (): NextApiRequestQuery =>
    getQueryFromUrl(window.location.search);
